<template>
    <el-dialog title="封禁司机" :before-close="handIsEnableClose" :visible.sync="show" destroy-on-close width="500px"
        append-to-body :close-on-click-modal="false">
        <el-form ref="banForm" :model="banForm" :rules="banRules" label-width="80px">
            <el-form-item label="封禁类型" prop="disableType">
                <el-radio-group v-model="banForm.disableType">
                    <el-radio :label="1">短期封禁</el-radio>
                    <el-radio :label="2">永久封禁</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="封禁天数" prop="disableDays" v-if="banForm.disableType === 1">
                <el-select v-model="banForm.disableDays" placeholder="请选择封禁天数">
                    <el-option :value="3" label="3天"></el-option>
                    <el-option :value="7" label="7天"></el-option>
                    <el-option :value="15" label="15天"></el-option>
                    <el-option :value="30" label="30天"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="封禁原因" prop="disableReason">
                <el-input type="textarea" v-model="banForm.disableReason" :maxlength="100" show-word-limit
                    placeholder="请输入封禁原因"></el-input>
                <div class="quick-reason">
                    <el-button size="mini" :type="isReasonSelected('司机切单') ? 'primary' : ''"
                        @click="quickSelectReason('司机切单')">司机切单</el-button>
                    <el-button size="mini" :type="isReasonSelected('违规收取高速费') ? 'primary' : ''"
                        @click="quickSelectReason('违规收取高速费')">违规收取高速费</el-button>
                    <el-button size="mini" :type="isReasonSelected('服务态度差') ? 'primary' : ''"
                        @click="quickSelectReason('服务态度差')">服务态度差</el-button>
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handIsEnableClose">取 消</el-button>
            <el-button type="primary" @click="submitBan" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>

export default {
    name: "driverBan",
    props: {
        show: {
            type: Boolean,
            default: false
        },
        driverId: {
            type: [String, Number],
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            banForm: {
                disableType: 1,
                disableDays: null,
                disableReason: '',
                driverId: null
            },
            banRules: {
                disableType: [{ required: true, message: '请选择封禁类型', trigger: 'change' }],
                disableDays: [{ required: true, message: '请选择封禁天数', trigger: 'change' }],
                disableReason: [{ required: true, message: '请输入封禁原因', trigger: 'blur' }]
            }
        };
    },
    created() {

    },
    watch: {
        show(val) {
            if (!val) {
                this.banForm = {
                    disableType: 1,
                    disableDays: null,
                    disableReason: '',
                    driverId: null
                };
            }
        }
    },
    methods: {
        handIsEnableClose() {
            this.$emit('close');
        },
        submitBan() {
            this.$refs.banForm.validate(async (valid) => {
                if (valid) {
                    let params = {
                        id: this.driverId,
                        isEnable: 2,
                        disableType: this.banForm.disableType,
                        disableDays: this.banForm.disableDays,
                        disableReason: this.banForm.disableReason
                    };
                    this.$emit('submitBan', params);
                }
            });
        },
        quickSelectReason(reason) {
            if (!this.banForm.disableReason) {
                this.banForm.disableReason = reason;
            } else if (!this.banForm.disableReason.includes(reason)) {
                this.banForm.disableReason = this.banForm.disableReason + '，' + reason;
            }
            
            if (this.banForm.disableReason.length + reason.length > 100) {
                this.banForm.disableReason = this.banForm.disableReason.slice(0, 100);
            }
            this.$refs.banForm.validateField('disableReason');
        },
        isReasonSelected(reason) {
            return this.banForm.disableReason && this.banForm.disableReason.includes(reason);
        },
    },
};
</script>

<style lang="less" scoped>
.quick-reason {
    margin-top: 10px;

    .el-button {
        margin-right: 10px;

        &:last-child {
            margin-right: 0;
        }
    }
}
</style>
